var parser = {};

export { parser as __exports };
//# sourceMappingURL=parser2.mjs.map
